const STORAGE_KEY = 'FORUM_GROUP_RETURN_ACTIONS';
let memoryActionStore = {};

const canUseSessionStorage = () =>
  typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

const normalizeId = (value) => {
  if (value === undefined || value === null) return '';
  return String(value);
};

const readActionStore = () => {
  if (!canUseSessionStorage()) return {};
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch (error) {
    return {};
  }
};

const writeActionStore = (store) => {
  memoryActionStore = store;
  if (!canUseSessionStorage()) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (error) {
    // In private mode memoryActionStore still keeps this page session consistent.
  }
};

const getActionStore = () => ({
  ...readActionStore(),
  ...memoryActionStore,
});

const updateGroupAction = (groupId, updater) => {
  const id = normalizeId(groupId);
  if (!id) return;
  const store = getActionStore();
  store[id] = updater(store[id] || {});
  writeActionStore(store);
};

export const markForumPostCreateSuccess = (groupId) => {
  updateGroupAction(groupId, (action) => ({
    ...action,
    postCreated: true,
  }));
};

export const markForumPostDeleted = (groupId, postId) => {
  const deletedId = normalizeId(postId);
  if (!deletedId) return;
  updateGroupAction(groupId, (action) => {
    const ids = Array.isArray(action.deletedPostIds) ? action.deletedPostIds.slice() : [];
    if (ids.indexOf(deletedId) < 0) ids.push(deletedId);
    return {
      ...action,
      deletedPostIds: ids,
    };
  });
};

export const takeForumGroupReturnAction = (groupId) => {
  const id = normalizeId(groupId);
  if (!id) return null;
  const store = getActionStore();
  const action = store[id];
  if (!action) return null;
  delete store[id];
  writeActionStore(store);
  const deletedPostIds = Array.isArray(action.deletedPostIds)
    ? action.deletedPostIds.map(normalizeId).filter(Boolean)
    : [];
  if (!action.postCreated && deletedPostIds.length === 0) return null;
  return {
    postCreated: action.postCreated === true,
    deletedPostIds,
  };
};
